import i18n from '@/i18n/locale';
import {
  getCustomerServicePhone,
  getBrandName
} from '@/utils/getCountyConfig'
import {
  sprintf
} from 'sprintf-js';


const csTelNumber = getCustomerServicePhone()
const brandTxT2 = getBrandName('brand_txt_2')

export default {
  normal: {
    title: i18n.t('超时赔付规则说明'),
    desc: [{
        // txt: ('当前订单（不含已取消订单）未在预计送达时间内送达，Didi Food将赔付给您一定金额的优惠券，订单完成后可以在'),
        txt: sprintf(i18n.t('soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在'), brandTxT2),
        highLight: 0
      },
      {
        txt: i18n.t('soda-c-i18n---个人中心的“优惠券”'),
        highLight: 1
      },
      {
        txt: i18n.t('中查看'),
        highLight: 0
      },
      {
        txt: i18n.t('FoodC_update_The_expected_ZzFg'),
        highLight: 0
      }
    ],
    rules: {
      title: i18n.t('详细说明'),
      detailConst: [
        // ('1、超时赔付服务是Didi Food为您免费提供的服务，延迟送达时间及赔付优惠券金额如下：'),
        sprintf(i18n.t('1、超时赔付服务是%s为您免费提供的服务，延迟送达时间及赔付优惠券金额如下：'), brandTxT2),
        i18n.t('2、超时赔付服务由平台为用户提供，用户没有支付任何费用，若订单取消则服务取消。'),
        [{
            // txt: ('3、您因超时赔付服务获得的优惠券，将发放至您的Didi Food账户，请在'),
            txt: sprintf(i18n.t('3、您因超时赔付服务获得的优惠券，将发放至您的%s账户，请在'), brandTxT2),
            highLight: 0
          },
          {
            txt: i18n.t('个人中心的“优惠券”'),
            highLight: 1
          },
          {
            txt: i18n.t('中查看'),
            highLight: 0
          }
        ],
        i18n.t('4、部分时间段下单暂不参加赔付；'),
        i18n.t('5、以下您方原因导致订单超时送达或无法送达的，将不会获得赔付：'),
        i18n.t('(1) 您要求更换收获地址、您提交的地址错误、联系不上您或无人收货、拒收等导致订单超时送达或无法送达的；'),
        i18n.t('(2) 因您的配送地址所在地不允许骑手入内，导致超时送达或无法送达的；'),
        i18n.t('(3) 其他因您的原因导致骑手超时送达或无法送达的。'),
        i18n.t('6、每位用户每天最多赔付6张优惠券；'),
        sprintf(i18n.t('7、请您对骑手的送达时间进行监督，如遇骑手提前点击送达而实际未能按照约定时间送达的，请您拨打%s客服电话%s进行投诉。'), brandTxT2, csTelNumber)
      ]
    }
  },
  abnormal: {
    title: i18n.t('超时赔付规则说明'),
    rules: {
      title: i18n.t('详细说明'),
      detailConst: [
        [{
            // txt: ('1、超时赔付服务是Didi Food为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，Didi Food将赔付给您一定金额的优惠券，订单完成后可以在中查看。'),
            txt: sprintf(i18n.t('soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。'), brandTxT2, brandTxT2),
            highLight: 0
          },
          {
            txt: i18n.t('soda-c-i18n---个人中心的“优惠券”'),
            highLight: 1
          },
          {
            txt: i18n.t('中查看'),
            highLight: 0
          },
          {
            txt: i18n.t('FoodC_update_The_expected_ZzFg'),
            highLight: 0
          }
        ],
        i18n.t('2、部分时间段下单暂不参加赔付；'),
        // ('早间：06:00-08:00'),
        // ('夜间：22:00-24:00'),
        i18n.t('3、恶劣天气（雨、雪等）暂不参加赔付；'),
        i18n.t('4、以下您方原因导致订单超时送达或无法送达的，将不会获得赔付：'),
        i18n.t('(1) 您要求更换收获地址、您提交的地址错误、联系不上您或无人收货、拒收等导致订单超时送达或无法送达的；'),
        i18n.t('(2) 因您的配送地址所在地不允许骑手入内，导致超时送达或无法送达的；'),
        i18n.t('(3) 其他因您的原因导致骑手超时送达或无法送达的。'),
        i18n.t('5、每位用户每天最多赔付6张优惠券；'),
        // ('6、请您对骑手的送达时间进行监督，如遇骑手提前点击送达而实际未能按照约定时间送达的，请您拨打Didi Food客服电话01800801688进行投诉。')
        sprintf(i18n.t('6、请您对骑手的送达时间进行监督，如遇骑手提前点击送达而实际未能按照约定时间送达的，请您拨打%s客服电话%s进行投诉。'), brandTxT2, csTelNumber)
      ]
    }
  }
}